import { useState } from "react";
import { MessageCircle, Phone, Mail, Instagram, Music2, Ghost, X } from "lucide-react";
import { WHATSAPP_URL } from "../lib/whatsapp";
import {
  PHONE_TEL,
  EMAIL_MAILTO,
  INSTAGRAM_URL,
  TIKTOK_URL,
  SNAPCHAT_URL,
} from "../lib/contact";

const actions = [
  { key: "email", label: "Email", href: EMAIL_MAILTO, icon: Mail },
  { key: "whatsapp", label: "WhatsApp", href: WHATSAPP_URL, icon: MessageCircle, external: true },
  { key: "call", label: "Call", href: PHONE_TEL, icon: Phone },
  { key: "instagram", label: "Instagram", href: INSTAGRAM_URL, icon: Instagram, external: true },
  { key: "tiktok", label: "TikTok", href: TIKTOK_URL, icon: Music2, external: true },
  { key: "snapchat", label: "Snapchat", href: SNAPCHAT_URL, icon: Ghost, external: true },
];

export const FloatingContact = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3 sm:bottom-7 sm:right-7">
      {open && (
        <div className="flex flex-col items-end gap-2" data-testid="floating-contact-menu">
          {actions.map(({ key, label, href, icon: Icon, external }) => (
            <a
              key={key}
              href={href}
              target={external ? "_blank" : undefined}
              rel={external ? "noopener noreferrer" : undefined}
              data-testid={`floating-contact-${key}`}
              className="reveal group flex items-center gap-3 border border-[rgba(201,162,75,0.5)] bg-[#111110] px-4 py-2.5 shadow-[0_8px_24px_rgba(0,0,0,0.5)] transition-colors duration-200 hover:bg-[#c9a24b]"
            >
              <Icon size={16} className="text-[#e6c87a] group-hover:text-[#0a0a09]" />
              <span className="text-xs font-semibold uppercase tracking-[0.15em] text-[#f2ede3] group-hover:text-[#0a0a09]">
                {label}
              </span>
            </a>
          ))}
        </div>
      )}
      <button
        type="button"
        aria-label={open ? "Close contact menu" : "Open contact menu"}
        aria-expanded={open}
        data-testid="floating-contact-toggle"
        onClick={() => setOpen((o) => !o)}
        className="flex h-14 w-14 items-center justify-center rounded-full border border-[rgba(201,162,75,0.6)] bg-[#111110] text-[#e6c87a] shadow-[0_8px_30px_rgba(0,0,0,0.6)] transition-colors duration-200 hover:bg-[#c9a24b] hover:text-[#0a0a09]"
      >
        {open ? <X size={22} /> : <MessageCircle size={24} />}
      </button>
    </div>
  );
};
